// extracted by mini-css-extract-plugin
export default {"wrapper":"KD-z","viewport":"LD-z","container":"MD-z","slide":"ND-z"};